(function (app, ng) {
    app.provider("notificationDialog", [function () {
        this.$get = ["$mdDialog", "$q", "_", function ($mdDialog, $q, _) {
            return {
                open: function (event) {                                  
                    return $mdDialog.show({                   
                        controller: "notificationsController",
                        controllerAs: "$ctrl",
                        templateUrl: "App/Home/Notifications/notifications-template.html",
                        clickOutsideToClose: false,
                        bindToController: true,
                        notification: event,                     
                        parent: ng.element(document.body),
                        targetEvent: event,                      
                        locals: {
                          
                        }
                    }).then(function (response) {
                        //console.log(response)
                        return response;
                    });
                }
            };
        }];
    }]);
})(window.app, window.angular); // jshint ignore:line